import React, { FunctionComponent } from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraSelfCareResourcesSpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 96 96' fill='none'>
      <Rect width='96' height='96' rx='48' fill={spotIllustration.background.fill} />
      <Path
        d='M47.8715 75.0099C59.3952 75.0099 68.7371 69.9251 68.7371 63.6526C68.7371 57.3802 59.3952 52.2954 47.8715 52.2954C36.3477 52.2954 27.0059 57.3802 27.0059 63.6526C27.0059 69.9251 36.3477 75.0099 47.8715 75.0099Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M48.5628 53.8032C56.8369 53.2057 63.2207 48.7014 62.8216 43.7426C62.4224 38.7838 55.3914 35.2483 47.1173 35.8458C38.8432 36.4434 32.4593 40.9476 32.8585 45.9064C33.2577 50.8652 40.2887 54.4008 48.5628 53.8032Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M57.1678 31.2089C57.821 27.682 54.1743 24.1289 49.0226 23.2729C43.8709 22.4169 39.1651 24.5822 38.5119 28.1091C37.8586 31.636 41.5054 35.189 46.657 36.045C51.8087 36.901 56.5145 34.7358 57.1678 31.2089Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
